export default __webpack_public_path__ + "static/media/supereggy.8074815d.png";